import { Outlet, RouteObject, useParams } from 'react-router'
import { ObjectTypes } from '../api/object'
import { useTableLayout } from '../layouts'
import { ObjectCreate } from '../objects/object-create'
import { ObjectEdit } from '../objects/object-edit'
import { ObjectsTable } from '../objects/objects'
import { Activity } from '../widget/activity'
import { Base } from './base'
import { Form } from './form'
import { Root } from './root'
import { Table } from './table'

export const PROPOSALS_ROUTES: RouteObject = {
	path: 'proposal/*',
	element: <Root />,
	children: [
		{
			path: '',
			index: true,
			element: <Table />,
		},
		{
			path: 'create',
			index: true,
			element: <Form redirect />,
		},
		{
			path: ':proposalId',
			element: <Outlet />,
			children: [
				{
					index: true,
					element: <Base />,
				},
				{
					path: 'logs',
					element: <ActivityRoute />,
				},
				{
					path: ':object',
					children: [
						{
							index: true,
							element: <RelatedObjects />,
						},
						{
							path: 'create',
							element: <ObjectCreate />,
						},
						{
							path: ':id',
							element: <ObjectEdit />,
						},
					],
				},
			],
		},
	],
}

function RelatedObjects() {
	const { proposalId = '', object = '' } = useParams()
	const { layout, isLoading } = useTableLayout(object, 'proposal', {
		type: 'relation',
	})

	if (isLoading) return null
	if (!layout) return null

	return (
		<ObjectsTable
			table={layout}
			object={object as keyof ObjectTypes}
			related={{ proposal_id: proposalId }}
		/>
	)
}

export function ActivityRoute() {
	const { proposalId = '' } = useParams()
	return <Activity object="proposal" id={proposalId} />
}
